import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02fb2b40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-inline-flex" }
const _hoisted_2 = { class: "d-flex flex-column mb-0 me-4" }
const _hoisted_3 = { class: "d-flex flex-column mb-0 me-4 align-items-center ps-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "container pln-modal" }
const _hoisted_6 = { class: "d-none d-lg-block modal-pln-overflow" }
const _hoisted_7 = { class: "d-flex align-items-center pln-product-header-container" }
const _hoisted_8 = { class: "item-appid" }
const _hoisted_9 = { class: "item-product" }
const _hoisted_10 = { class: "item-qty" }
const _hoisted_11 = { class: "item-desc" }
const _hoisted_12 = { class: "item-date" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "action" }, null, -1))
const _hoisted_14 = { class: "item-appid" }
const _hoisted_15 = { class: "item-product" }
const _hoisted_16 = { class: "item-qty" }
const _hoisted_17 = { class: "item-desc" }
const _hoisted_18 = { class: "item-date" }
const _hoisted_19 = { class: "action d-inline-flex flex-row" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "scroll-mobile d-lg-none" }
const _hoisted_22 = { class: "row w-100" }
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = { class: "item-appid" }
const _hoisted_25 = { class: "col-6 pln-product-item-container" }
const _hoisted_26 = { class: "item-appid" }
const _hoisted_27 = { class: "row w-100" }
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = { class: "item-product" }
const _hoisted_30 = { class: "col-6 pln-product-item-container" }
const _hoisted_31 = { class: "item-product" }
const _hoisted_32 = { class: "row w-100" }
const _hoisted_33 = { class: "col-6" }
const _hoisted_34 = { class: "item-qty" }
const _hoisted_35 = { class: "col-6 pln-product-item-container" }
const _hoisted_36 = { class: "item-qty" }
const _hoisted_37 = { class: "row w-100" }
const _hoisted_38 = { class: "col-6" }
const _hoisted_39 = { class: "item-desc" }
const _hoisted_40 = { class: "col-6 pln-product-item-container" }
const _hoisted_41 = { class: "item-desc" }
const _hoisted_42 = { class: "row w-100" }
const _hoisted_43 = { class: "col-6" }
const _hoisted_44 = { class: "item-date" }
const _hoisted_45 = { class: "col-6 pln-product-item-container" }
const _hoisted_46 = { class: "item-date" }
const _hoisted_47 = { class: "row w-100" }
const _hoisted_48 = { class: "col-12" }
const _hoisted_49 = { class: "action d-inline-flex flex-row justify-content-between w-100" }
const _hoisted_50 = ["src"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_AsahiTypography, {
          type: "headline-medium",
          class: "primary-light-green-text"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('1PLN')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_AsahiTypography, {
          type: "body-2-bold",
          class: "primary-light-green-text"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('products')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AsahiTypography, {
          type: "subtitle-3",
          class: "primary-light-green-text ps-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("b", null, _toDisplayString(_ctx.productFreeBeer.length), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t( _ctx.productFreeBeer.length === 1 ? 'product available' : 'products available')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('Application ID')), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('Product')), 1),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('Quantity')), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('Description')), 1),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('Application validity date')), 1),
          _hoisted_13
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productFreeBeer, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "d-flex align-items-center pln-product-item-container",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(item.req_id), 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_16, _toDisplayString(item.qty), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(item.product_desc), 1),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatDate(item.valid_to)), 1),
            _createElementVNode("div", _hoisted_19, [
              (item.item_id === '0')
                ? (_openBlock(), _createBlock(_component_AsahiButton, {
                    key: 0,
                    type: "primary",
                    onClick: ($event: any) => (_ctx.setFreeBeerProduct(item,'addtocart'))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Add to cart')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : (item.item_id)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_AsahiButton, { type: "success" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('In cart')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_AsahiButton, {
                        type: "icon",
                        onClick: ($event: any) => (_ctx.setFreeBeerProduct(item,'remove'))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", { src: _ctx.remove }, null, 8, _hoisted_20)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 64))
                  : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_21, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productFreeBeer, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('Application ID')), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, _toDisplayString(item.req_id), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('Product')), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, _toDisplayString(item.name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('Quantity')), 1)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, _toDisplayString(item.qty), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('Description')), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, _toDisplayString(item.product_desc), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('Application validity date')), 1)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.formatDate(item.valid_to)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  (item.item_id === '0')
                    ? (_openBlock(), _createBlock(_component_AsahiButton, {
                        key: 0,
                        type: "primary",
                        onClick: ($event: any) => (_ctx.setFreeBeerProduct(item,'addtocart'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Add to cart')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (item.item_id)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_AsahiButton, { type: "success" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('In cart')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AsahiButton, {
                            type: "icon",
                            onClick: ($event: any) => (_ctx.setFreeBeerProduct(item,'remove'))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", { src: _ctx.remove }, null, 8, _hoisted_50)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ], 64))
                      : _createCommentVNode("", true)
                ])
              ])
            ]),
            _hoisted_51
          ]))
        }), 128))
      ])
    ])
  ], 64))
}